export enum ParentClinicOption {
  All = 'all',
  ParentClinics = 'parentClinics',
}
